import React from 'react';
import { BuildingIcon, PlusIcon, MailIcon, PhoneIcon, ShieldCheckIcon, MoreVerticalIcon } from 'lucide-react';
export function UnderwriterModule({
  role
}: {
  role: string;
}) {
  const underwriters = [{
    id: 'UW-001',
    name: 'Leadway Assurance Plc',
    type: 'Composite',
    naicom: 'RIC-024',
    contact: 'Sarah Johnson',
    email: 'partners@leadway.com',
    phone: '+234 1 280 0700',
    products: 4,
    sla: '98%',
    status: 'Active'
  }, {
    id: 'UW-002',
    name: 'AXA Mansard',
    type: 'General',
    naicom: 'RIC-042',
    contact: 'David Okeke',
    email: 'digital@axamansard.com',
    phone: '+234 1 448 5482',
    products: 2,
    sla: '95%',
    status: 'Active'
  }, {
    id: 'UW-003',
    name: 'Hygeia HMO',
    type: 'Health',
    naicom: 'HMO-001',
    contact: 'Dr. Amina Bello',
    email: 'providers@hygeiahmo.com',
    phone: '+234 1 270 0480',
    products: 1,
    sla: '99%',
    status: 'Active'
  }, {
    id: 'UW-004',
    name: 'Cornerstone Insurance',
    type: 'Composite',
    naicom: 'RIC-011',
    contact: 'Tunde Bakare',
    email: 'tech@cornerstone.com.ng',
    phone: '+234 1 280 6500',
    products: 2,
    sla: '92%',
    status: 'Active'
  }, {
    id: 'UW-005',
    name: 'Heirs Life Assurance',
    type: 'Life',
    naicom: 'RIC-088',
    contact: 'Ngozi Eze',
    email: 'partners@heirslifeassurance.com',
    phone: '+234 1 277 4444',
    products: 0,
    sla: '-',
    status: 'Onboarding'
  }];
  return <div className="space-y-6" data-id="element-753">
      <div className="flex justify-between items-center" data-id="element-754">
        <div data-id="element-755">
          <h2 className="text-2xl font-bold text-[#0D3B3B]" data-id="element-756">
            Underwriter Registry
          </h2>
          <p className="text-sm text-gray-500" data-id="element-757">
            Manage partner insurance companies and SLA tracking.
          </p>
        </div>
        {role === 'Super Admin' && <button className="bg-[#0D3B3B] text-white px-4 py-2 rounded-xl font-bold text-sm flex items-center gap-2 hover:bg-[#092D2D] transition-colors" data-id="element-758">
            <PlusIcon className="w-4 h-4" data-id="element-759" /> Add Underwriter
          </button>}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-760">
        {underwriters.map(uw => <div key={uw.id} className="bg-white rounded-2xl border border-gray-100 shadow-sm p-6 hover:shadow-md transition-shadow" data-id="element-761">
            <div className="flex justify-between items-start mb-4" data-id="element-762">
              <div className="w-12 h-12 rounded-xl bg-slate-100 flex items-center justify-center text-slate-600" data-id="element-763">
                <BuildingIcon className="w-6 h-6" data-id="element-764" />
              </div>
              <button className="p-2 text-gray-400 hover:text-[#0D3B3B] rounded-lg hover:bg-gray-50" data-id="element-765">
                <MoreVerticalIcon className="w-5 h-5" data-id="element-766" />
              </button>
            </div>

            <h3 className="font-bold text-[#0D3B3B] text-lg mb-1" data-id="element-767">{uw.name}</h3>
            <div className="flex items-center gap-2 mb-4" data-id="element-768">
              <span className="text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-769">
                {uw.type}
              </span>
              <span className="w-1 h-1 bg-gray-300 rounded-full" data-id="element-770"></span>
              <span className="text-xs text-gray-500" data-id="element-771">{uw.naicom}</span>
            </div>

            <div className="space-y-2 mb-6" data-id="element-772">
              <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-773">
                <MailIcon className="w-4 h-4 text-gray-400" data-id="element-774" />
                <span className="truncate" data-id="element-775">{uw.email}</span>
              </div>
              <div className="flex items-center gap-3 text-sm text-gray-600" data-id="element-776">
                <PhoneIcon className="w-4 h-4 text-gray-400" data-id="element-777" />
                <span data-id="element-778">{uw.phone}</span>
              </div>
            </div>

            <div className="grid grid-cols-3 gap-2 pt-4 border-t border-gray-100" data-id="element-779">
              <div className="text-center" data-id="element-780">
                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1" data-id="element-781">
                  Products
                </p>
                <p className="text-sm font-bold text-[#0D3B3B]" data-id="element-782">
                  {uw.products}
                </p>
              </div>
              <div className="text-center border-l border-gray-100" data-id="element-783">
                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1" data-id="element-784">
                  SLA
                </p>
                <p className={`text-sm font-bold ${uw.sla === '-' ? 'text-gray-400' : parseInt(uw.sla) >= 95 ? 'text-emerald-600' : 'text-amber-600'}`} data-id="element-785">
                  {uw.sla}
                </p>
              </div>
              <div className="text-center border-l border-gray-100" data-id="element-786">
                <p className="text-[10px] text-gray-400 font-bold uppercase tracking-wider mb-1" data-id="element-787">
                  Status
                </p>
                <span className={`inline-flex items-center px-2 py-0.5 rounded-md text-[10px] font-bold ${uw.status === 'Active' ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-700'}`} data-id="element-788">
                  {uw.status}
                </span>
              </div>
            </div>
          </div>)}
      </div>
    </div>;
}